import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogout = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.6875 21.875C4.27083 21.875 3.90625 21.7188 3.59375 21.4062C3.28125 21.0938 3.125 20.7292 3.125 20.3125V4.6875C3.125 4.27083 3.28125 3.90625 3.59375 3.59375C3.90625 3.28125 4.27083 3.125 4.6875 3.125H12.2656V4.6875H4.6875V20.3125H12.2656V21.875H4.6875ZM17.3438 17.0573L16.224 15.9375L18.8802 13.2812H9.76562V11.7188H18.8281L16.1719 9.0625L17.2917 7.94271L21.875 12.526L17.3438 17.0573Z",
		fill: "#CF4130"
	})
});
export default SvgLogout;
